// extracted by mini-css-extract-plugin
export var columnList = "_cj-0";